function quadIn(t) {
  return t * t
}

module.exports = quadIn


//////////////////
// WEBPACK FOOTER
// ./node_modules/eases/quad-in.js
// module id = 148
// module chunks = 0